import customTips from '@assets/css/custom-tips.css';

/**
 * Custom tips styles.
 * @type {CSSStyleSheet}
 */
export const customTipsStyles = new CSSStyleSheet();
customTipsStyles.replaceSync(customTips);
